const assetType = {
  IMAGE: '1',
  VIDEO: '2',
  AUDIO: '3',
  FONT: '4',
  PDF:'5'
};

export default assetType;
